import React from 'react';
import Sidebar from './Sidebar';

const Layout = ({ children }) => {
  return (
    <div className='container mx-auto'>
      <div className="grid grid-cols-9 gap-2">
        <div className="col-span-11 md:col-span-2">
          <Sidebar/>
        </div>
        <div className="col-span-11  md:col-span-7">
          {children}
        </div>
      </div>

    </div>
  );
};

export default Layout;